// Imports Angular
import { Compiler } from '@angular/core';
import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Logger } from 'angular2-logger/core';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { SessionStorageService } from 'ngx-webstorage';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Imports DIAN
import { DContextoMuiscaServicio, DContextoMuiscaDesaServicio, DLogger, DLoggerAngular, DSessionStorage } from '@dian/core';
import { DFormularioServicio} from '@dian/api-formulario';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DValidacionesFormularioServicio, DOperacionesMatematicasServicio, DInterfaceConfiguracionFormulario, DAyudasFormularioServicio, DInterfaceAyudaFormulario } from '@dian-cmp/formulario';


const is_desa = false;

export function loggerFactory (logger:Logger, sessionStorage:SessionStorageService) {
    return new DLoggerAngular(logger, sessionStorage);     
}

export function sessionStorageFactory(sessionStorage:SessionStorageService,logger:DLogger) {
	return new DSessionStorage(sessionStorage,logger);    
}

export function contextoMuiscaFactory (http:Http, cookieService:CookieService, compiler:Compiler, logger:DLogger, dNotificacionServicio:DNotificacionServicio, sessionStorage:DSessionStorage, configuracion: DInterfaceConfiguracionFormulario) {
    let invitado = configuracion.SOLO_USUARIO_INVITADO;
    if (is_desa) {                   
        return new DContextoMuiscaDesaServicio(http, cookieService, compiler, logger, dNotificacionServicio, sessionStorage, invitado);                   
    } else {
        return new DContextoMuiscaServicio(http, cookieService, compiler, logger, dNotificacionServicio, sessionStorage, invitado);
    }
}

export function formularioFactory(contextoServicio:DContextoMuiscaServicio) {
    return new DFormularioServicio(contextoServicio);    
}

//Factory para cargar la directiva que realiza las validaciones de los formularios
export function validacionesFormularioFactory (configuracion: DInterfaceConfiguracionFormulario, dutilidades:DOperacionesMatematicasServicio) {
	return new DValidacionesFormularioServicio(configuracion, dutilidades);
}

//Traductor
export function HttpLoaderTranslatorFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}




// WEBPACK FOOTER //
// D:/Desarrollo/workspace_160v2/Aplicacion/test/FormularioIngreso160/src/app/configuracion/app.factories.ts